import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import mapSettings from '../mapSettings'
import { setUserPreference, getUsersPreference } from 'common/utils/UserPreferences'

const ZoomInLocationReminderGL = () => {
  const [isVisible, setIsVisible] = useState(true)
  const [isDismissed, setIsDismissed] = useState(false)
  const currentZoom = useSelector((state) => state.mapProperties.zoomLevel)
  const mapAvailable = useSelector((state) => state.mapProperties.mapAvailable)

  // check preferences once, on initial render
  useEffect(() => {
    const getReminderDismissalStatus = async () => {
      const storedDismissalStatus = await getUsersPreference('zoom_in_reminder_dismissed')
      const dismissalStatus = storedDismissalStatus ?? false
      setIsDismissed(dismissalStatus)
    }
    getReminderDismissalStatus()
  }, [])

  // update visibility based on map availability and dismissal status
  useEffect(() => {
    if(mapAvailable && !isDismissed) {
      setIsVisible(true)
    }
  }, [mapAvailable, isDismissed])

  if(!mapAvailable) {
    return null
  }

  const notifierClassName = `zoom-location-reminder-gl nomobile ${isVisible ? '' : 'fade-out'}`
  const displayNotifier = currentZoom && !isDismissed && currentZoom < mapSettings.zoomReminderInMinZoom

  const handleClose = () => {
    setIsVisible(false)
    // eslint-disable-next-line camelcase
    setUserPreference({ zoom_in_reminder_dismissed: true })
  }

  if(displayNotifier) {
    return (
      <div className={notifierClassName}>
        <span className="rounded centered nomobile">
          <div className="close no-btn small">
            <i
              className="fas fa-times"
              onClick={handleClose}
            ></i>
          </div>
          Use the
          <i className="fa fa-crosshairs fa-lg margin-left-sm margin-right-sm"></i>
          button<br />
          to zoom to your location
        </span>
      </div>
    )
  } else {
    return null
  }
}

export default ZoomInLocationReminderGL
